export class MergeUsers {
  public date: Date;
  public description: string;
  constructor() {}
}
